import { render, staticRenderFns } from "./TimeScale.vue?vue&type=template&id=531c42fe&scoped=true"
import script from "./TimeScale.vue?vue&type=script&lang=js"
export * from "./TimeScale.vue?vue&type=script&lang=js"
import style0 from "./TimeScale.vue?vue&type=style&index=0&id=531c42fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c42fe",
  null
  
)

export default component.exports